import { useState } from "react";
import { useHistory } from "react-router";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";
import { LoginData, login } from "../hooks/auth-hook";
import { useFormData } from "../hooks/formHooks";
import { fieldError } from "../utils";

export function LoginComponent(props: {}) {
    const [data, setField] = useFormData<LoginData>({} as any);
    const [invalidError, setInvalidError] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const history = useHistory()

    return <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
        <Grid.Column style={{ maxWidth: 450 }}>
            <Header as='h2' color='teal' textAlign='center'>
                Log-in to your account
            </Header>
            <Form loading={loading} size='large' onSubmit={e => {
                e.preventDefault();
                setLoading(true);

                login(data).then(currentUser => {
                    let lastRoute = localStorage.getItem('last_route') || '/';
                    if (lastRoute.startsWith('/login')) {
                        lastRoute = '/'
                    }

                    localStorage.removeItem('last_route');
                    history.push(lastRoute);
                }).catch(resp => {
                    if (resp.status === 2) {
                        setInvalidError(resp.data);
                    }
                }).finally(() => setLoading(false))
            }}>
                <Segment stacked>
                    <Form.Input fluid icon='user' iconPosition='left' placeholder='Email' name="email" value={data.email || ''} onChange={(e, d) => setField(e, {name: 'email', value: d.value.trim()})} error={fieldError('email', invalidError)} />
                    <Form.Input
                        fluid
                        icon='lock'
                        iconPosition='left'
                        placeholder='Password'
                        type='password'
                        name="password"
                        value={data.password || ''} onChange={setField}
                        error={fieldError('password', invalidError)}
                    />

                    <Button color='teal' fluid size='large'>
                        Login
                    </Button>
                </Segment>
            </Form>
        </Grid.Column>
    </Grid>
}